import { render, staticRenderFns } from "./FundsChangeCard.vue?vue&type=template&id=5c13bd20&scoped=true"
import script from "./FundsChangeCard.vue?vue&type=script&lang=js"
export * from "./FundsChangeCard.vue?vue&type=script&lang=js"
import style0 from "./FundsChangeCard.vue?vue&type=style&index=0&id=5c13bd20&prod&lang=less&scoped=true"
import style1 from "./FundsChangeCard.vue?vue&type=style&index=1&id=5c13bd20&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c13bd20",
  null
  
)

export default component.exports